import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Pagination from 'components/Pagination';
import Select from 'components/Select';
import Modal from 'components/Modal';
import { Spinner } from 'triider-components';
import { Creators as DashCreators } from 'store/ducks/dash';
import { colors } from 'stylesheets';
import { selectInvoices, selectFilter } from 'utils/select';
import Row from '../Row';

import {
  List,
  Buttons,
  SelectStyled,
  Footer,
  Loader,
  Content,
  Text,
  Label,
} from './styles';

const PaymentTicket = ({
  paymentTicket, setPaymentTicket, _getPaymentTickets, paymentTickets, _position, _positionFilter, loadingVisible, total,
}) => {
  const [offset, setOffset] = useState(false);
  const [position, setPosition] = useState(0);
  const [positionFilter, setPositionFilter] = useState(0);
  const [limit, setLimit] = useState(false);
  const [interval, sInterval] = useState(false);
  const [filter, setFilter] = useState(false);

  const listPaymentTickets = () => {
    _getPaymentTickets({
      offset: offset || 0,
      limit: limit || 5,
      interval: interval || 1,
      filter: filter || null,
      position,
      positionFilter,
    });
  };

  useEffect(() => {
    listPaymentTickets();
  }, [paymentTicket, offset, interval, positionFilter]);

  const handlePaymentTicket = () => {
    setPaymentTicket(!paymentTicket);
  };

  const handleInterval = (e) => {
    const { value } = e.target;
    sInterval(selectInvoices.value[value]);
    setPosition(value);
  };

  const handleFilter = (e) => {
    const { value } = e.target;
    setFilter(selectFilter.value[value]);
    setPositionFilter(value);
  };

  return (
    <Modal
      ticket
      closebutton
      modallist={paymentTicket.toString()}
      isOpen={paymentTicket}
      borderbottomheader="none"
      paddingheader="40px"
      textalingheader="initial"
      backgroundcolor={colors.blueLight}
      backgroundclip="padding-box"
      padding="0px 40px 40px;"
      width="1000px"
      title="PAGAMENTOS PENDENTES"
      disabled={false}
      toggle={handlePaymentTicket}
    >
      {loadingVisible ? (
        <Loader>
          <Spinner size="larger" />
        </Loader>
      ) : (
        <Content>
          <Buttons>
            <SelectStyled>
              <Label>Data:</Label>
              <Select
                value={_position || 1}
                options={selectInvoices.name}
                onChange={handleInterval}
              />
            </SelectStyled>
            <SelectStyled>
              <Label>Status:</Label>
              <Select
                value={_positionFilter || 0}
                options={selectFilter.name}
                onChange={handleFilter}
              />
            </SelectStyled>
          </Buttons>

          {!total && (
            <Text>Sem Boletos :(</Text>
          )}

          <List>
            {paymentTickets
              && paymentTickets.map((t, key) => <Row key={key} ticket={t} />)
            }
          </List>

          {!!paymentTickets.length && (
            <Footer>
              <Pagination
                total={total}
                listMaxLength={5}
                offset={offset}
                setOffset={pageOffset => setOffset(pageOffset)}
              />
            </Footer>
          )}
        </Content>
      )}
    </Modal>
  );
};

const mapStateToProps = state => ({
  paymentTickets: state.dash.paymentTickets.list,
  total: state.dash.paymentTickets.total,
  _position: state.dash.paymentTickets.position,
  _positionFilter: state.dash.paymentTickets.positionFilter,
  loadingVisible: state.ui.loaders.includes('PAYMENT_TICKET_LIST'),
});

const mapDispatchToProps = {
  _getPaymentTickets: DashCreators.getPaymentRequestDashRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentTicket);
